import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-cell-plug-assignee",
  "use": "icon-cell-plug-assignee-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-cell-plug-assignee\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M10 8a2 2 0 1 1 4 0 2 2 0 0 1-4 0Z\" fill=\"currentColor\" /><path d=\"M7.667 14.589C8.479 13.013 10.15 12 12 12c1.849 0 3.52 1.013 4.333 2.589l.567 1.1.89-.458-.89.458c.29.562-.106 1.311-.875 1.311h-8.05c-.769 0-1.165-.75-.875-1.311l.567-1.1Z\" stroke=\"currentColor\" stroke-width=\"2\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol